import axios from 'axios'
export default {

  async add (obj) {
    try {
      obj.updated_at = Date.now()
      obj.created_at = Date.now()
      delete obj._id

      const response = await axios.post('extras/add', obj)
      if (response.status === 200) {
        console.log('extras agregada correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al agregar extras:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al agregar extras:', error)
      return false
    }
  },

  async edit (obj) {
    try {
      obj.updated_at = Date.now()
      const response = await axios.patch('extras/update', obj)
      if (response.status === 200) {
        console.log('extras editado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al editar extras:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al editar extras:', error)
      return false
    }
  },

  async listByBussines (businesId, search, page) {
    try {
      const response = await axios.get('extras/listByBusiness?business=' + businesId + '&search=' + search + '&page=' + page)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async listByPos (terminalId, search, page) {
    try {
      const response = await axios.get('extras/listByPos?terminal=' + terminalId + '&search=' + search + '&page=' + page)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async delete (obj) {
    try {
      obj.deleted_at = Date.now()
      const response = await axios.patch('extras/delete', obj)
      if (response.status === 200) {
        console.log('extra editado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al editar el extra:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al editar el extra:', error)
      return false
    }
  }

}
